export default "__VITE_ASSET__DCD1SM62__"